import {
  CheckIcon,
  DownloadIcon,
  HeartIcon,
  PlayIcon,
  SearchIcon,
  LinkIcon,
} from "@heroicons/react/outline";

// eslint-disable-next-line import/prefer-default-export
export const buttonIcons = {
  check: CheckIcon,
  download: DownloadIcon,
  heart: HeartIcon,
  play: PlayIcon,
  search: SearchIcon,
  share: LinkIcon,
};
